module.exports = __webpack_public_path__ + "static/media/hands_26.d6733cdb.svg";